import type { ReactNode } from 'react';
import { AuthLink } from './primitives/AuthLink';

const ANAKA_ICON = '/assets/anaka_icon.png';
const GLOW =
  'radial-gradient(closest-side, rgba(124,58,237,0.20), transparent 70%), radial-gradient(closest-side, rgba(59,130,246,0.14), transparent 72%)';

/**
 * Full-screen auth shell: wordmark-only top chrome, blueprint grid + ambient
 * brand glow, a centred stage for the card, a contextual footer line, and the
 * legal links. Theme is ambient (`.dark`); the grid/glow have `.dark` variants.
 */
export function LoginShell({ children, footer }: { children: ReactNode; footer?: ReactNode }) {
  return (
    <div className="anaka-app relative flex min-h-screen w-full flex-col overflow-hidden bg-[var(--background-subtle)] font-sans text-foreground">
      <div className="bg-grid-blueprint pointer-events-none absolute inset-0" aria-hidden="true" />
      <div
        className="pointer-events-none absolute"
        aria-hidden="true"
        style={{
          top: '6%',
          left: '50%',
          width: 640,
          height: 560,
          transform: 'translateX(-50%)',
          background: GLOW,
          backgroundPosition: '32% 38%, 70% 60%',
          backgroundRepeat: 'no-repeat',
          filter: 'blur(6px)',
        }}
      />

      <header className="relative z-[2] flex h-[60px] flex-none items-center border-b border-border px-7 backdrop-blur-xl">
        <div className="flex items-center gap-2.5">
          <img src={ANAKA_ICON} alt="" className="size-[26px]" />
          <span className="text-[18px] font-bold tracking-[-0.02em] text-foreground">Anaka</span>
        </div>
      </header>

      <main className="relative z-[1] flex min-h-0 flex-1 flex-col items-center justify-center gap-4 px-7 py-7">
        {children}
        {footer && <div className="text-[13px] text-muted-foreground">{footer}</div>}
      </main>

      <footer className="relative z-[1] flex flex-none items-center justify-center gap-3 pb-5 text-[12.5px] text-[var(--foreground-subtle)]">
        <AuthLink href="/privacy">Privacy Policy</AuthLink>
        <span className="opacity-50">·</span>
        <AuthLink href="/terms">Terms &amp; Conditions</AuthLink>
      </footer>
    </div>
  );
}
